module.exports = __webpack_public_path__ + "static/media/img5.9fb9357a.jpg";